import { CLEAR_ERRORS_SHOWING, HIDE_ERROR, SHOW_ERROR } from '@instructure/quiz-common';
export function clearErrorsShowing() {
  return {
    type: CLEAR_ERRORS_SHOWING,
    payload: {}
  };
}
export function showError(key) {
  return {
    type: SHOW_ERROR,
    payload: {
      key: key
    }
  };
}
export function hideError(key) {
  return {
    type: HIDE_ERROR,
    payload: {
      key: key
    }
  };
}